module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    ref: "numeric",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "tel"
    },
    domProps: {
      "value": _vm.value,
      "value": (_vm.amount)
    },
    on: {
      "blur": _vm.formatValue,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }, function($event) {
        _vm.processValue(_vm.amountValue)
      }],
      "focus": function($event) {
        _vm.convertToNumber(_vm.numberValue)
      }
    }
  }) : _c('span', {
    ref: "readOnly"
  }, [_vm._v(" " + _vm._s(_vm.amount) + " ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5baacc67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-numeric/src/vue-numeric.vue
// module id = 922
// module chunks = 3